var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AssemblySheetForm',{attrs:{"readonly-mode":false,"assembly-sheet":_vm.assemblySheet}})
}
var staticRenderFns = []

export { render, staticRenderFns }